import { DropdownIcon } from "@/components/Icons"
import type { SimpleOption } from "@/utils/form/constants"
import { type DropdownIndicatorProps, type GroupBase, components } from "react-select"

export default <T extends SimpleOption, isMulti extends boolean>(
  dropdownIndicatorProps: DropdownIndicatorProps<T, isMulti, GroupBase<T>>
) => (
  <components.DropdownIndicator {...dropdownIndicatorProps}>
    <DropdownIcon color="text" boxSize={5} />
  </components.DropdownIndicator>
)
